import {
  axios,
} from '@/utils/request'
// 获取所有课程列表
export function getCueseLists(data) {
  return axios({
    url: '/training/training/info/list',
    method: 'get',
    params: data
  })
}
// 修改课程
export function changeCueseInfo(data) {
  return axios({
    url: '/training/training/info',
    method: 'put',
    data: data
  })
}
// 获取课程详细信息
export function getCueseInfo(data) {
  return axios({
    url: '/training/training/info/' + data.id,
    method: 'get',
  })
}
// 新增课程
export function saveCueseInfo(data) {
  return axios({
    url: '/training/training/info',
    method: 'post',
    data: data
  })
}
// 查询所有课程
export function getAllCourse(data) {
  return axios({
    url: '/training/training/info/allCourse',
    method: 'get',
    params: data
  })
}
// 查询课程类别
export function getCategoryLis(data) {
  return axios({
    url: '/training/training/category/list',
    method: 'get',
    params: data
  })
}
// 删除未发布课程
export function delCategory(data) {
  return axios({
    url: '/training/training/info/' + data.ids,
    method: 'delete',
    params: data
  })
}
// ----------------------------------------------------- 题库管理 ------------------------------------------------------
// 获取题目列表
export function getQuestionLis(data) {
  return axios({
    url: '/training/tra_question/info_list',
    method: 'get',
    params: data
  })
}
// 删除题目
export function delQuestionLis(data) {
  return axios({
    url: '/training/tra_question/info/' + data.id,
    method: 'delete',
  })
}
// 查询题目详情
export function getQuestionDetail(data) {
  return axios({
    url: '/training/tra_question/info',
    method: 'get',
    params: data
  })
}
// 新增题目
export function addQuestion(data) {
  return axios({
    url: '/training/tra_question/info',
    method: 'post',
    data: data
  })
}
// 编辑题目
export function updateQuestion(data) {
  return axios({
    url: '/training/tra_question/info',
    method: 'put',
    data: data
  })
}
// 删除图片
export function delUploadImg(data) {
  return axios({
    url: '/file/file/delete',
    method: 'get',
    params: data
  })
}

// ----------------------------------------------------- 培训管理 ------------------------------------------------------
// 获取培训完成率考核通过率
export function manage_getrate(data) {
  return axios({
    url: '/training/training/manage/getRate',
    method: 'get',
    params: data
  })
}
// 获取培训完成率考核通过率
export function manage_more_getrate(data) {
  return axios({
    url: '/training/training/manage/getMoreRate',
    method: 'get',
    params: data
  })
}
// 获取培训管理列表
export function manage_getlist(data) {
  let params = {
    pageIndex: data.pageIndex,
    pageSize: data.pageSize
  }
  return axios({
    url: '/training/training/manage/newList',
    method: 'post',
    data: data,
    params: params
  })
}
// 获取培训管理列表详情
export function getTrainingDetail(data) {
  return axios({
    url: '/training/training/manage/getTrainingDetail',
    method: 'get',
    params: data
  })
}
// 获取培训类型列表详情
export function getCategoryList(data) {
  return axios({
    url: '/training/training/category/list',
    method: 'get',
    params: data
  })
}
// 获取文件列表
export function getFileUrl(data) {
  return axios({
    url: '/file/file/getUrls',
    method: 'get',
    params: data
  })
}
// 上传文件
export function uploadFile(data) {
  return axios({
    url: '/file/file/upload',
    method: 'post',
    data: data
  })
}
export function addcategory(data) {
  return axios({
    url: '/training/training/category',
    method: 'post',
    data: data
  })
}
// 修改培训类型
export function editcategory(data) {
  return axios({
    url: '/training/training/category',
    method: 'put',
    data: data
  })
}
// 获取学时目标列表
export function getHourList(data) {
  return axios({
    url: '/training/training/hour/list',
    method: 'get',
    params: data
  })
}
// 获取学时目标列表
export function editHourInfo(data) {
  return axios({
    url: '/training/training/hour',
    method: 'put',
    data: data
  })
}
// 检查部门是否有学时目标
export function checkedHourInfo(data) {
  return axios({
    url: '/training/training/hour/checked?deptId=' + data.deptId,
    method: 'post',
    data: data
  })
}
// 添加新学时目标列表
export function addHourInfo(data) {
  return axios({
    url: '/training/training/hour',
    method: 'post',
    data: data
  })
}
// 获取证书列表
export function getCertificateList(data) {
  return axios({
    url: '/training/training/certificate/list',
    method: 'get',
    params: data
  })
}
// 获取证书pdf
export function getCertificateInfo(data) {
  return axios({
    url: '/training/training/certificate/downloadCertificate',
    method: 'get',
    params: data
  })
}
// 获取证书编号列表
export function getIdentifierList(data) {
  return axios({
    url: '/training/training/post/list',
    method: 'get',
    params: data
  })
}
// 获取证书编号详细信息
export function getIdentifierDetail(data) {
  return axios({
    url: '/training/training/post/' + data.id,
    method: 'get',
    params: data
  })
}
// 修改证书编号
export function editIdentifierList(data) {
  return axios({
    url: '/training/training/post',
    method: 'put',
    data: data
  })
}
// 新增证书编号
export function addIdentifierList(data) {
  return axios({
    url: '/training/training/post',
    method: 'post',
    data: data
  })
}
// 获取用户列表
export function getCompanyUsers(data) {
  return axios({
    url: '/training/training/post/getUser',
    method: 'get',
    params: data
  })
}
// 获取用户列表
export function getbatchCompanyUsers(data) {
  return axios({
    url: '/training/training/post/getUsers/' + data.companyIds,
    method: 'get',
    params: data
  })
}
// 批量绑定用户
export function identifierbindPost(data) {
  return axios({
    url: `/training/training/post/bindPost?postId=${data.postId}&userIds=${data.userIds}`,
    method: 'post',
    data: data
  })
}
// 批量解除绑定用户
export function identifierunbindPost(data) {
  return axios({
    url: '/training/training/post/unbindPost?userIds=' + data.userIds,
    method: 'post',
    data: data
  })
}
// 删除证书岗位
export function delIdentifierList(data) {
  return axios({
    url: '/training/training/post/' + data.id,
    method: 'delete',
    data: data
  })
}
// ----------------------------------------------------- 创建考试 ------------------------------------------------------
// 获取考试列表信息
export function getExamList(data) {
  return axios({
    url: '/training/training/customize/exam/list',
    method: 'get',
    params: data
  })
}
// 创建考试
export function customizeExam(data) {
  return axios({
    url: '/training/training/customize/exam',
    method: 'post',
    data: data
  })
}
// 编辑考试
export function editExam(data) {
  return axios({
    url: '/training/training/customize/exam',
    method: 'put',
    data: data
  })
}
// 获取课程信息列表（创建考试、编辑考试）
export function getCourseInfoList(data) {
  return axios({
    url: '/training/training/customize/exam/getCourseInfoList',
    method: 'get',
    params: data
  })
}
// 考试发布
export function issueExamInfo(data) {
  return axios({
    url: '/training/training/customize/exam/issueExamInfo',
    method: 'post',
    data: data
  })
}
// 编辑考试添加参与人员
export function editExamUser(data) {
  return axios({
    url: '/training/training/customize/exam/editExamUser',
    method: 'post',
    data: data
  })
}
// 课程考试列表
export function myexam_list(data) {
  return axios({
    url: '/training/training/customize/myexam/list',
    method: 'get',
    data: data
  })
}
// 自定义试卷
export function tra_question_custom(data) {
  return axios({
    url: '/training/tra_question/custom',
    method: 'get',
    params: data
  })
}
// 提交自定义试卷
export function submit_costom(data) {
  return axios({
    url: '/training/tra_question/submit_costom',
    method: 'post',
    data: data
  })
}
// 修改课程上下架状态
export function changeCourseMarketState(data) {
  return axios({
    url: '/training/training/info/changeCourseMarketState',
    method: 'put',
    data: data
  })
}
// 获取公司列表下课程类别
export function getTrainCategoryList(data) {
  return axios({
    url: '/training/training/category/getTrainCategoryList/' + data.companyIds,
    method: 'get',
    params: data,
  })
}
// 获取公司所属下所有课程
export function getCompanyCourseInfoList(data) {
  return axios({
    url: '/training/training/info/companyCourseInfoList',
    method: 'get',
    params: data,
  })
}
// 获取公司所属下所有课程
export function getCompanyCourseInfoLists(data) {
  return axios({
    url: '/training/training/info/companyCourseInfoLists/' + data.companyIds,
    method: 'get',
    params: data,
  })
}
// 批量发布考试
export function issueExamInfoBatch(data) {
  return axios({
    url: '/training/training/customize/exam/issueExamInfoBatch',
    method: 'post',
    data: data,
  })
}

export const letterLis = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
]